import localforage from 'localforage';

const ONE_SECOND = 1000;
const ONE_MINUTE = ONE_SECOND * 60;
const ONE_HOUR = ONE_MINUTE * 60;
const ONE_DAY = ONE_HOUR * 24;

let deleteStore: LocalForage;

/**
 * 初始化本地缓存数据库
 * @returns true 初始化成功 false 初始化失败
 */
export function initLocalDB(): boolean {
  return localforage.config({
    name: 'bifrost',
    storeName: 'bifrost',
    description: '记录本地缓存数据',
  });
}

/**
 * 本地缓存数据
 * 如果对应key已存在则会更新数据
 * @param key 缓存key
 * @param data 缓存的数据
 * @param duration 缓存时长[毫秒] 默认永久
 * @returns 缓存的数据
 */
export async function save<T>(key: string, data: T, duration = 0) {
  const res = await localforage.setItem<T>(key, data);
  if (duration) {
    const expire = Date.now() + duration;
    await setKeyExpire(key, expire);
  } else {
    removeKeyExpire(key);
  }
  return res;
}

/**
 * 删除某个缓存
 * @param key 需要删除的key
 * @param delay 延时删除 [毫秒]
 * @returns
 */
export async function remove(key: string, delay = 0) {
  if (delay) {
    await setKeyExpire(key, Date.now() + delay);
  } else {
    await localforage.removeItem(key);
    removeKeyExpire(key);
  }
}

/**
 * 查询一个缓存
 * @param key 缓存key
 * @returns data
 */
export async function query<T>(key: string) {
  return localforage.getItem<T>(key);
}

/**
 * 是否存在某个key
 * @param key 数据key
 */
export async function hasKey(key: string) {
  const keys = await localforage.keys();
  return keys.includes(key);
}
/**
 * 清除过期数据
 */
export function clearExpireData() {
  if (!deleteStore) {
    deleteStore = localforage.createInstance({
      name: 'barzeb',
      storeName: '_barzeb',
      description: '记录需要删除的数据',
    });
  }
  deleteStore
    .iterate((value, key, _) => {
      if (typeof value === 'number' && value < Date.now()) {
        remove(key);
      }
      return void 0;
    })
    .catch(err => {
      console.log(err);
    });
}

async function setKeyExpire(key: string, expire: number) {
  if (!deleteStore) {
    deleteStore = localforage.createInstance({
      name: 'barzeb',
      storeName: '_barzeb',
      description: '记录需要删除的数据',
    });
  }
  await deleteStore.setItem(key, expire);
}

async function removeKeyExpire(key: string) {
  if (!deleteStore) {
    deleteStore = localforage.createInstance({
      name: 'barzeb',
      storeName: '_barzeb',
      description: '记录需要删除的数据',
    });
  }
  await deleteStore.removeItem(key);
}

const localdb = { initLocalDB, save, remove, query, hasKey, clearExpireData, ONE_SECOND, ONE_MINUTE, ONE_HOUR, ONE_DAY };
export default localdb;
